import React from 'react';
import { NotificationManager } from 'react-notifications';
import { GetPrefixUniversity } from "../MainApp";
import { AppSetting } from '../common/function'
class UserData {
  AppSetting = AppSetting();
  constructor() {
      this.getUserDetails();
  }

  getUserDetails() {
    if(this.AppSetting){
        this.GivenName = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_GivenName`);
        this.USER_NAME = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_USER_NAME`);
        this.UnixEpoch = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_UnixEpoch`);
        this.emailid = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_emailid`);
        this.role = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`)?parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`),10):0;
        this.token = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`);
        this.loginAttemptAccess = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_loginAttemptAccess`);
        this.syncAccess= window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_syncAccess`);
        this.timeZone= window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`);
    }else{
        setTimeout(() => {
          this.getUserDetails();
        }, 5000)
    }
  }

  setUserDetails(userData) {
    if(userData){
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_GivenName`, userData.GivenName);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_USER_NAME`, userData.USER_NAME);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_UnixEpoch`, userData.UnixEpoch);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_emailid`, userData.emailid);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`, userData.role);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`, userData.authtoken);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_loginAttemptAccess`, userData.loginAttemptAccess);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_syncAccess`, userData.syncAccess);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`, userData.timeZone);
      window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_courseCreationAccess`, userData.courseCreationAccess);

    }

  }

  hasValidData() {
      if (this.USER_NAME !== undefined && this.USER_NAME !== null && this.USER_NAME !== "" 
      && this.token !== undefined && this.token !== null && this.token !== "" && (this.role === 2 || this.role === 1) )
          return true;
      return false;
  }

  clearSessionData() {
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_GivenName`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_USER_NAME`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_UnixEpoch`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_emailid`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_loginAttemptAccess`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_syncAccess`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`);
      window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_courseCreationAccess`);
      this.emailid = null;
      this.GivenName = null;
      this.role = null;
      this.token = null;
      this.UnixEpoch = null;
      this.USER_NAME = null;
      this.loginAttemptAccess = null;
      this.syncAccess = null;
      this.timeZone=null;
      this.enableLTI = false;
      window.location.reload();
      
  }

  removeUserDetails() {
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_GivenName`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_USER_NAME`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_UnixEpoch`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_emailid`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_loginAttemptAccess`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_syncAccess`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`);
    window.localStorage.removeItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_courseCreationAccess`);
  }
}

export default class Properties {
  universityPrefix = GetPrefixUniversity();
  constructor() {
    if(window.localStorage.getItem(`${this.universityPrefix}_CpanelAppsettings`)!== null){
      const AppSetting = JSON.parse(window.localStorage.getItem(`${this.universityPrefix}_CpanelAppsettings`));
      this.baseURL = AppSetting.REACT_APP_APIURL.trim();
      this.stemFluencyUrl = AppSetting.REACT_APP_APIURL.trim().split('/')[2];
      this.enableLogin = JSON.parse(AppSetting.REACT_APP_ENABLE_LOGIN);
      this.appURL = AppSetting.REACT_APP_URL;
      if (AppSetting.REACT_APP_BASE_FOLDER !== undefined) {
        this.baseFolder = AppSetting.REACT_APP_BASE_FOLDER;
      } else this.baseFolder = '/';
      this.currentUserData = new UserData();
      this.loginType = AppSetting.REACT_APP_LOGIN_TYPE?AppSetting.REACT_APP_LOGIN_TYPE.trim():'shiboleth';
      this.mailDomain = AppSetting.REACT_APP_MAIL_DOMAIN?AppSetting.REACT_APP_MAIL_DOMAIN.trim():'osu.edu';
      this.enableLTI =  AppSetting.REACT_APP_ENABLE_LTI?JSON.parse(AppSetting.REACT_APP_ENABLE_LTI):false;
      this.schoolMode =  AppSetting.REACT_APP_SCHOOL_MODE?JSON.parse(AppSetting.REACT_APP_SCHOOL_MODE):false;
      this.copyright =  AppSetting.REACT_APP_COPYRIGHT?JSON.parse(AppSetting.REACT_APP_COPYRIGHT):false;
      this.eqmMode =  AppSetting.REACT_APP_EQM_MODE?JSON.parse(AppSetting.REACT_APP_EQM_MODE):false;
      this.universityFullName = AppSetting?.univFullName;
    }else{
      this.currentUserData = new UserData();
    }
  }
}